<template>
  <main class="admin-entry-page" aria-live="polite">
    <section class="entry-status" role="status">
      <i v-if="!failed" class="el-icon-loading" aria-hidden="true" />
      <i v-else class="el-icon-warning-outline entry-error" aria-hidden="true" />
      <h1>{{ failed ? '进入失败' : '正在进入用户前台' }}</h1>
      <p>{{ message }}</p>
      <el-button v-if="failed" type="primary" @click="goToLogin">返回登录</el-button>
    </section>
  </main>
</template>

<script>
import { loginWithImpersonationTicket } from '../services/auth'

export default {
  name: 'AdminEntryPage',
  data() {
    return { failed: false, message: '请稍候，即将自动打开。' }
  },
  async created() {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''))
    const ticket = params.get('ticket') || ''
    window.history.replaceState(null, document.title, this.$route.path)
    if (!ticket) {
      this.showFailure('进入凭证缺失，请返回管理后台重试。')
      return
    }
    try {
      await loginWithImpersonationTicket(ticket)
      await this.$router.replace({ name: 'home' })
    } catch (error) {
      this.showFailure(error.message || '进入失败，请返回管理后台重试。')
    }
  },
  methods: {
    showFailure(message) { this.failed = true; this.message = message },
    goToLogin() { this.$router.replace({ name: 'login' }) }
  }
}
</script>

<style scoped>
.admin-entry-page{min-height:100vh;display:grid;place-items:center;box-sizing:border-box;padding:24px;background:#f5f7fa;color:#303133}.entry-status{width:min(420px,100%);box-sizing:border-box;border:1px solid #e4e7ed;border-radius:10px;padding:42px 28px;background:#fff;box-shadow:0 12px 32px rgba(31,45,61,.08);text-align:center}.entry-status>i{display:block;margin-bottom:18px;color:#409eff;font-size:38px}.entry-status>.entry-error{color:#e6a23c}.entry-status h1{margin:0 0 10px;font-size:20px}.entry-status p{margin:0;color:#606266;font-size:14px;line-height:1.7}.entry-status .el-button{min-height:40px;margin-top:22px}@media(prefers-reduced-motion:reduce){.entry-status>i{animation:none}}
</style>
